import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthStateInterface } from "./interfaces";
// import { UserRoles } from "constant";

const initialState: AuthStateInterface = {
  isLoading: false,
  jwtData: null
};

export const mainSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    initTokenRequest: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    initTokenSuccess: (state) => {
      state.isLoading = false;
    },
    initTokenError: (state) => {
      state.isLoading = false;
    },
    shareTokenRequest: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    shareTokenSuccess: (state) => {
      state.isLoading = false;
    },
    shareTokenError: (state) => {
      state.isLoading = false;
    },

    setTokenData: (state, { payload }) => {
      state.jwtData = payload;
    },

    signOutRequest: () => {},
    signOutSuccess: () => {},
    signOutError: () => {}
  }
});

export const { actions, reducer } = mainSlice;
